import { render } from "./public-facility-card.vue?vue&type=template&id=2b2d76c5&scoped=true"
import script from "./public-facility-card.vue?vue&type=script&lang=js"
export * from "./public-facility-card.vue?vue&type=script&lang=js"

import "./public-facility-card.vue?vue&type=style&index=0&id=2b2d76c5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2d76c5"]])

export default __exports__